module.exports = __webpack_public_path__ + "static/error-ig-6-7b2fbde9da9af9abc59b59c8d692f0fa.png";